// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__v9FKw","menuToggle":"header_menuToggle__1TlFL","toggled":"header_toggled__uDSUk","disabled":"header_disabled__2kQwe","logo":"header_logo__1X7aW"};